/**
 * SkipToContent — keyboard-only "skip to main content" link.
 *
 * MUST be the FIRST focusable element on every page. The visible target
 * lives at `<main id="main-content" tabIndex={-1}>` so screen-reader users
 * land directly on the page content, bypassing the navigation chrome.
 *
 * Styling lives in `src/styles/index.css` under the `.skip-link` class
 * (logical inset properties so RTL flips automatically).
 *
 * WCAG 2.4.1 (Bypass Blocks) — Level A.
 */
import type { TranslateFn } from "#/lib/i18n.js";

export type SkipToContentProps = {
  t: TranslateFn;
  /** Override target id; default is `main-content`. */
  targetId?: string;
};

export function SkipToContent({
  t,
  targetId = "main-content",
}: SkipToContentProps) {
  return (
    <a href={`#${targetId}`} className="skip-link">
      {t("accessibility:skipToContent")}
    </a>
  );
}
